const gameLoadFinish = () => {
  window.HiyaJSBridge.callHandler("gameLoadFinish");
};
export {
  gameLoadFinish
};
